import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { ThemeProvider } from 'styled-components';

import '@fontsource/syne';
import '@fontsource/syne/500.css';
import '@fontsource/syne/600.css';
import '@fontsource/syne/700.css';
import '@fontsource/syne/800.css';

import CookieConsent from './src/components/CookieConsent/CookieConsent';
import { mainTheme } from './src/styles/globalStyles';
import { trackPageview } from './src/utils/trackers';

/**
 * Mounts the consent card on every page.
 *
 * There is no shared Layout component — each page wraps itself in GlobalStyle
 * and ThemeProvider — so the card is mounted here with its own provider. It is
 * browser-only by design: the decision to show it depends on the visitor's
 * timezone and stored consent, neither of which exists at build time.
 */
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
    element,
}) => (
    <>
        {element}
        <ThemeProvider theme={mainTheme}>
            <CookieConsent />
        </ThemeProvider>
    </>
);

/**
 * Reports client-side navigation to Google Analytics.
 *
 * gatsby-plugin-google-gtag used to do this; it was removed so that GA cannot
 * load before consent. Mintance handles SPA navigation on its own.
 */
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
    trackPageview(location.pathname);
};
